import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Shown after login to a restaurant_admin whose restaurant has no POS chosen
 * yet (`pos_provider: 'none'`). Ordering stays off until they enable Fork &
 * Find or connect Square / Clover / Swirepay. "Later" only hides it for this session —
 * HomePageComponent shows it again on the next login while still `none`.
 */
@Component({
  selector: 'app-choose-pos-modal',
  standalone: true,
  templateUrl: './choose-pos-modal.component.html',
  styleUrl: './choose-pos-modal.component.css',
})
export class ChoosePosModalComponent {
  /** True while the Enable Fork & Find request is in flight. */
  @Input() loading = false;
  /** Hide the Square / Clover / Swirepay option when the connect page isn't
   * reachable (Hardware, or every POS provider, feature-flagged off). */
  @Input() canConnectPos = false;
  @Output() enableFnf = new EventEmitter<void>();
  @Output() connectPos = new EventEmitter<void>();
  @Output() later = new EventEmitter<void>();
}
